export default "__VITE_ASSET__C_v$RHCy__ 608w";